// Read helpers for the logged-in user's profile settings (myUser.settings).
export const Settings = {
	getValue: function(settingName) {
		return Settings.getSetting(settingName);
	},
	getSetting: function(settingName) {
		if(window.myUser && window.myUser.settings) {
			return window.myUser.settings[settingName];
		}
		return null;
	},
	isChecked: function(settingName) {
		return !!Settings.getSetting(settingName);
	},
};
